// extracted by mini-css-extract-plugin
export default {"details_table":"Account_details_table__Ppmgr","action_buttons":"Account_action_buttons__34haF"};